var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "contentContainer", staticClass: "fill-height main-container" },
    [
      !_vm.isUnitySupported
        ? _c("div", { staticClass: "empty-content text-h4" }, [
            _c("p", [_vm._v(_vm._s(_vm.unitySupportMessage))]),
            _c("canvas", {
              ref: "emptyCanvas",
              attrs: { width: "1", height: "1" },
            }),
          ])
        : _c(
            "div",
            {
              ref: "editorContainer",
              staticClass: "editor-interface",
              class: { "stack-inner": _vm.stackEditor },
            },
            [
              _c("EditorActionBar", {
                staticClass: "editor-actions",
                attrs: {
                  isHorizontalView: _vm.stackEditor,
                  isLoading: _vm.isUnityLoading || _vm.isOpeningLoad,
                  isEditMode: _vm.isEditScene,
                  isPoseMode: _vm.isPoseScene,
                  hasUnsavedChanges: _vm.hasUnsavedChanges,
                  isBackendBusy: _vm.isUpdatingData,
                  isPendingBuild: _vm.isBuildQueued,
                  isProcessingBuild:
                    !_vm.isBuildQueued &&
                    (_vm.isProcessingBuild || !!_vm.pendingBuildAction),
                  isPendingShare: _vm.isPendingShare,
                  isSharing: _vm.isSharingCharacter,
                  shareLevel: _vm.shareLevel,
                  isQueryingShareLevel: !!_vm.queryingShareId,
                  showAccount: !_vm.isAppBarVisible,
                  isAccountPaid: _vm.isAccountPaid,
                },
                on: {
                  "info-action": _vm.onInfoDialogAction,
                  "save-changes": function ($event) {
                    return _vm.saveChanges("actions")
                  },
                  "mailing-list": _vm.onMailingListDialogAction,
                  "toggle-build-pose": function ($event) {
                    return _vm.onToggleBuildPoseAction(true)
                  },
                  "start-download": _vm.onStartDownloadAction,
                  "preview-generated": _vm.onPreviewGeneratedAction,
                  "restore-dimensions": _vm.onRestoreAction,
                  "share-character": _vm.onShareCharacter,
                  "estimate-pose": _vm.onEstimatePose,
                  "open-account-pay": _vm.openAccountPay,
                  "open-character-browser": _vm.openCharacterBrowser,
                },
              }),
              _c(
                "Unity3dContainer",
                {
                  ref: "unityContainer",
                  staticClass: "unity-container",
                  attrs: {
                    buildPathUri: "/unityBuild/day6-editor",
                    background: _vm.unityCanvasBackground,
                    companyName: "quickytools",
                    productName: "qharacter",
                    canvasOpacity: _vm.unityCanvasLoadOpacity,
                    freeInput: "",
                  },
                  on: {
                    "load-progress": _vm.onUnityLoading,
                    "load-complete": _vm.onUnityLoaded,
                    "unity-start-error": _vm.onUnityError,
                    "script-load-error": _vm.onUnityError,
                  },
                },
                [
                  _c(
                    "div",
                    { attrs: { id: "canvas-interior" } },
                    [
                      _vm.isUnityLoading
                        ? _c("v-progress-circular", {
                            staticClass: "center-loading-indicator",
                            attrs: {
                              color: _vm.loadingIndicatorUi.color,
                              width: _vm.loadingIndicatorUi.size,
                              indeterminate: "",
                            },
                          })
                        : _vm._e(),
                      _vm.isColorPickerVisible
                        ? _c("v-color-picker", {
                            class: {
                              "bottom-gravity": _vm.isSmallScreen,
                              "top-space":
                                !_vm.isSmallScreen && _vm.isPreviewScene,
                            },
                            attrs: {
                              id: "color-picker",
                              "canvas-height": _vm.colorPickerHeight,
                              width: _vm.colorPickerWidth,
                              "hide-inputs": _vm.isSmallScreen,
                            },
                            model: {
                              value: _vm.selectedColor,
                              callback: function ($$v) {
                                _vm.selectedColor = $$v
                              },
                              expression: "selectedColor",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm.enableAnimationFeatures
                    ? _c("CharacterPoseSequencesView", {
                        ref: "poseSequencesView",
                        staticClass: "pose-sequences-view",
                        attrs: {
                          hasChanges: _vm.isPoseChanged,
                          isSavingChanges: _vm.isSavingData,
                          isSavingNew: _vm.isSavingNewPoseSequence,
                          isSavingName: _vm.isSavingPoseSequenceName,
                          isDeletingSequence: _vm.isDeletingPoseSequence,
                          isLoadingSequence:
                            _vm.isLoadingAnimations ||
                            _vm.isLoadingPoseSequence,
                          activeSequenceId: _vm.activePoseSequenceId,
                          nameChangingId: _vm.poseSequenceNameChangingId,
                          deletingId: _vm.poseSequenceDeletingId,
                        },
                        on: {
                          "on-close-view": _vm.focusUnity,
                          "save-changes": function ($event) {
                            return _vm.saveChanges("pose")
                          },
                          "open-pose-sequences": _vm.onOpenPoseSequences,
                          "load-pose-sequence": _vm.onLoadPoseSequence,
                          "new-pose-sequence": _vm.onNewPoseSequence,
                          "update-pose-sequence-name":
                            _vm.onUpdatePoseSequenceName,
                          "delete-pose-sequence": _vm.onDeletePoseSequence,
                        },
                        model: {
                          value: _vm.characterAnimationsCache,
                          callback: function ($$v) {
                            _vm.characterAnimationsCache = $$v
                          },
                          expression: "characterAnimationsCache",
                        },
                      })
                    : _vm._e(),
                  _vm.isKeyframeTimelineVisible && _vm.enableAnimationFeatures
                    ? _c(
                        "div",
                        { staticClass: "keyframe-timeline-container" },
                        [
                          _c(
                            "div",
                            { staticClass: "keyframe-timeline-inner" },
                            [
                              _c("KeyframeTimeline", {
                                ref: "keyframeTimeline",
                                staticClass: "keyframe-timeline",
                                attrs: {
                                  frameRange: _vm.timelineViewFrameRange,
                                  "canvas-padding": 8,
                                },
                                on: {
                                  "on-frame-range-change":
                                    _vm.onKeyframeRangeChange,
                                  "on-active-frame-index":
                                    _vm.onActiveKeyframeIndex,
                                  "shift-frames": _vm.onShiftKeyframes,
                                  "delete-frames": _vm.onDeleteKeyframes,
                                  "toggle-play-pause": _vm.unityTogglePlayPause,
                                  "keyboard-navigate":
                                    _vm.unityPoseSequenceNavigate,
                                },
                                model: {
                                  value: _vm.animationKeyframes,
                                  callback: function ($$v) {
                                    _vm.animationKeyframes = $$v
                                  },
                                  expression: "animationKeyframes",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.isPreviewScene && _vm.showPreviewPlayback
                    ? _c("div", { staticClass: "preview-playback-container" }, [
                        _c("div", { staticClass: "preview-playback-inner" }, [
                          _c(
                            "div",
                            { staticClass: "preview-playback-actions" },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { icon: "", color: "accent" },
                                  on: { click: _vm.onPreviewRewind },
                                },
                                [_c("v-icon", [_vm._v(_vm._s(_vm.mdiRewind))])],
                                1
                              ),
                              _c(
                                "v-btn",
                                {
                                  attrs: { icon: "", color: "accent" },
                                  on: { click: _vm.onPreviewTogglePlayPause },
                                },
                                [
                                  _c("v-icon", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.isPreviewPlayingAnimation
                                          ? _vm.mdiPause
                                          : _vm.mdiPlay
                                      )
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
      _c("FullDialog", {
        ref: "fullDialog",
        on: {
          "dialog-action": _vm.onDialogAction,
          "on-close": _vm.onDialogClose,
        },
      }),
      _c("Day6Info", {
        attrs: { isTouchMode: _vm.showTouchInfoUi },
        model: {
          value: _vm.showInfoDialog,
          callback: function ($$v) {
            _vm.showInfoDialog = $$v
          },
          expression: "showInfoDialog",
        },
      }),
      _c("MailingListDialog", {
        attrs: {
          "list-key": "day6-marketing",
          title: _vm.day6Resource.day6Updates,
        },
        model: {
          value: _vm.showMailingListDialog,
          callback: function ($$v) {
            _vm.showMailingListDialog = $$v
          },
          expression: "showMailingListDialog",
        },
      }),
      _c(
        "v-dialog",
        {
          attrs: { loading: _vm.isEstimatingPose, "max-width": "360" },
          model: {
            value: _vm.showPoseEstimateDialog,
            callback: function ($$v) {
              _vm.showPoseEstimateDialog = $$v
            },
            expression: "showPoseEstimateDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("ImagePoseProvider", {
                staticClass: "pa-4",
                on: {
                  "is-estimating": function ($event) {
                    _vm.isEstimatingPose = true
                  },
                  "pose-data": _vm.onPoseEstimateResult,
                },
              }),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "", color: "accent" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.onEstimatePoseAction(-1)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.commonResource.cancel))]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "", color: "accent" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.onEstimatePoseAction(0)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.commonResource.close))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            fullscreen: _vm.isSmallScreen,
            "hide-overlay": _vm.isSmallScreen,
            "max-width": "800",
          },
          model: {
            value: _vm.showDataBrowser,
            callback: function ($$v) {
              _vm.showDataBrowser = $$v
            },
            expression: "showDataBrowser",
          },
        },
        [
          _c(
            "div",
            { staticClass: "data-browser-frame" },
            [
              _c("CharacterModelBrowser", {
                ref: "characterBrowser",
                attrs: {
                  "character-id-summary": _vm.dimensionsIdSummary,
                  "has-changes": _vm.hasUnsavedChanges,
                  "is-saving-changes": _vm.isSavingData,
                  "is-loading": _vm.isLoadingCharacter,
                },
                on: {
                  "save-changes": function ($event) {
                    return _vm.saveChanges("character")
                  },
                  "new-character": _vm.onBrowserNewCharacter,
                  "load-character": _vm.onBrowserLoadCharacter,
                  "on-character-delete": _vm.onCharacterDelete,
                  "close-browser": function ($event) {
                    _vm.showDataBrowser = false
                  },
                },
              }),
            ],
            1
          ),
        ]
      ),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "400" },
          model: {
            value: _vm.showPersistentDialog,
            callback: function ($$v) {
              _vm.showPersistentDialog = $$v
            },
            expression: "showPersistentDialog",
          },
        },
        [
          _c(
            "div",
            { staticClass: "loading-modal d-flex flex-row align-center" },
            [
              _c("v-progress-circular", {
                attrs: {
                  color: _vm.loadingIndicatorUi.color,
                  width: _vm.loadingIndicatorUi.size,
                  indeterminate: "",
                },
              }),
              _c("p", { staticClass: "body-1 ml-4 mb-0" }, [
                _vm._v(_vm._s(_vm.persistentDialogMessage)),
              ]),
            ],
            1
          ),
        ]
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "400" },
          model: {
            value: _vm.showAssetBuildTimeEstimateDialog,
            callback: function ($$v) {
              _vm.showAssetBuildTimeEstimateDialog = $$v
            },
            expression: "showAssetBuildTimeEstimateDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _vm._v(_vm._s(_vm.day6Resource.buildTimeEstimate)),
              ]),
              _c(
                "v-card-text",
                [
                  _c("p", { staticClass: "body-1" }, [
                    _vm._v(_vm._s(_vm.day6Resource.assetBuildEstimate())),
                  ]),
                  _c("v-checkbox", {
                    attrs: {
                      label: _vm.day6Resource.hideFutureMessage,
                      color: "accent",
                      disabled: _vm.hideBuildTimeEstimateAlert,
                    },
                    model: {
                      value: _vm.hideBuildTimeEstimateAlert,
                      callback: function ($$v) {
                        _vm.hideBuildTimeEstimateAlert = $$v
                      },
                      expression: "hideBuildTimeEstimateAlert",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "accent", text: "" },
                      on: {
                        click: function ($event) {
                          _vm.showAssetBuildTimeEstimateDialog = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.commonResource.ok))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          attrs: {
            timeout: _vm.snackbarTimeout,
            color: "accent",
            centered: _vm.isSmallScreen,
            top: !_vm.isSmallScreen,
            rounded: "pill",
          },
          model: {
            value: _vm.snackbar,
            callback: function ($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar",
          },
        },
        [_vm._v(_vm._s(_vm.snackbarText))]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }